import type { z } from 'zod'
import type { apiZod } from '@/shared/api'

// snake_case DTO → camelCase; size_bytes у бэка bigint — сужаем до number
// (картинки ≤ 11 MiB, влезает без потерь).
type BackgroundDto = z.infer<typeof apiZod.zBackgroundView>

export function toBackground(dto: BackgroundDto) {
  return {
    id: dto.id,
    name: dto.name,
    isSystem: dto.is_system,
    contentType: dto.content_type,
    sizeBytes: Number(dto.size_bytes),
    createdAt: dto.created_at,
  }
}
